import React from 'react';
import { colors } from '../../config/constants';
import './ToggleButton.css';

interface ToggleButtonProps {
  isOn: boolean;
  handleToggle: (arg: React.ChangeEvent<HTMLInputElement>) => void;
}

const ToggleButton = (props: ToggleButtonProps) => {
  const { isOn, handleToggle } = props;

  return (
    <div data-testid="toggle-wrapper">
      <input
        checked={isOn}
        onChange={handleToggle}
        className="switch-checkbox hidden"
        id={`switch`}
        type="checkbox"
        data-testid="toggle-input"
      />
      <label
        style={{ background: isOn ? '#27374d' : 'grey' }}
        className={`switch-label flex items-center justify-between cursor-pointer w-[40px] h-[20px] ${colors.primary} rounded-xl relative`}
        htmlFor={`switch`}
      >
        <span
          className={`switch-button flex items-center justify-between cursor-pointer w-[40px] h-[20px] ${colors.primary} rounded-xl relative`}
        />
      </label>
    </div>
  );
};

export default ToggleButton;
